import { Trans, useTranslation } from 'react-i18next'
import moment from 'moment'
import { useMonthlyReturnRate } from '@/application/queries'
import { Base, ReverCard, ReverLoading } from '@itsrever/design-system'
import { NoData } from '@/ui/shared'
import { AreaReturnRateGraph } from './area-return-rate-graph'
import { ReturnRateAIInsights } from './ai-insights/return-rate-ai-insights'
import { useAnalyticsScope } from '@/hooks'

export const ReturnRateByMonthArea = () => {
  const { t } = useTranslation()

  const { isGroupView } = useAnalyticsScope()
  const startMonth = moment()
    .subtract(12, 'M')
    .startOf('month')
    .format('YYYY-MM-DD')

  const endMonth = moment().subtract(1, 'M').endOf('month').format('YYYY-MM-DD')

  const { returnRatesByMonth, refundRatesByMonth, monthNames, loading } =
    useMonthlyReturnRate(startMonth, endMonth)

  const noData =
    !returnRatesByMonth.length &&
    !refundRatesByMonth.length &&
    !monthNames.length

  return (
    <ReverCard className="h-[425px] min-w-[400px] flex-1 p-3" fullWidth>
      <div className="h-full">
        <div className="flex justify-between">
          <div className="flex items-center">
            <p className="ml-2 mr-1">
              {t('returns_analytics.return_rate_month')}
            </p>
            <Base.InfoTooltip
              label={t('returns_analytics.about_return_rate_month')}
              content={
                <Trans
                  i18nKey="returns_analytics.chart_title_tooltip_rate"
                  components={{
                    b: <b />,
                    br: <br />
                  }}
                />
              }
            />
          </div>
          {/* Single-portal analysis, and mounting it calls useEcommerceId(), which would
              dispatch the first portal and collapse the group scope. */}
          {isGroupView ? null : <ReturnRateAIInsights />}
        </div>
        {loading ? (
          <div className="flex h-full items-center justify-center">
            <ReverLoading />
          </div>
        ) : noData ? (
          <NoData />
        ) : (
          <AreaReturnRateGraph
            returnRates={returnRatesByMonth}
            refundRates={refundRatesByMonth}
            names={monthNames}
          />
        )}
      </div>
    </ReverCard>
  )
}
